var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',{attrs:{"title":_vm.$t('violations.title'),"owner-violations":""}},[_c('ModernTable',{attrs:{"columns":_vm.table.columns,"rows":_vm.table.rows,"filters":{
      show: true
    },"loading":_vm.table.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }